module.exports = __webpack_public_path__ + "img/esrb-rating--pending.f0ad73b5.png";